import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import { ChangeOriginButton } from './ChangeOriginButton';
import { ItineraryItemCard } from './ItineraryItemCard';
import styles from './ItineraryTimeline.module.css';
import { TripBoundaryStay } from './TripBoundaryStay';
import type { ItineraryTimelineGroupProps } from './TripItinerary.types';
import { getItemDayNumber } from './transformItinerary';
export function ItineraryTimelineGroup(t0) {
  const $ = _c(43);
  const {
    group,
    isFirstGroup,
    isLastGroup,
    originLocationName,
    isEditable,
    tripId,
    returnLegId,
    cardSection: t1,
    accommodationStaysByItemId
  } = t0;
  const cardSection = t1 === undefined ? "overview" : t1;
  const canEditBoundaryStays = cardSection === "overview";
  let t2;
  if ($[0] !== group.items) {
    t2 = group.items.at(-1);
    $[0] = group.items;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const lastItem = t2;
  const hasEndStay = isLastGroup && lastItem?.type === "Stay";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className={styles.timelineDot} aria-hidden="true" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== group.dayLabel) {
    t4 = <span>{group.dayLabel}</span>;
    $[3] = group.dayLabel;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== group.dateRange) {
    t5 = group.dateRange && <span className={styles.timelineDate}>{group.dateRange}</span>;
    $[5] = group.dateRange;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <h4 className={styles.timelineHeading}>{t4}{t5}</h4>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isLastGroup) {
    t7 = !isLastGroup && <span className={styles.timelineTrack} aria-hidden="true" />;
    $[10] = isLastGroup;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isEditable || $[13] !== originLocationName || $[14] !== tripId) {
    t8 = originLocationName && isEditable && <ChangeOriginButton originName={originLocationName} tripId={tripId} />;
    $[12] = isEditable;
    $[13] = originLocationName;
    $[14] = tripId;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== canEditBoundaryStays || $[17] !== isFirstGroup) {
    t9 = canEditBoundaryStays && isFirstGroup && <TripBoundaryStay position="start" />;
    $[16] = canEditBoundaryStays;
    $[17] = isFirstGroup;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== accommodationStaysByItemId || $[20] !== canEditBoundaryStays || $[21] !== cardSection || $[22] !== group || $[23] !== hasEndStay || $[24] !== lastItem || $[25] !== returnLegId || $[26] !== tripId) {
    t10 = group.items.map(item => <Fragment key={item.id}>{canEditBoundaryStays && hasEndStay && item === lastItem && <TripBoundaryStay position="end" />}<ItineraryItemCard item={item} section={cardSection} tripId={tripId} isReturnLeg={returnLegId !== null && item.id === returnLegId} dayNumber={getItemDayNumber(group, item.startDate)} accommodationStay={item.type === "Stay" ? accommodationStaysByItemId?.get(item.stayItemId) : undefined} /></Fragment>);
    $[19] = accommodationStaysByItemId;
    $[20] = canEditBoundaryStays;
    $[21] = cardSection;
    $[22] = group;
    $[23] = hasEndStay;
    $[24] = lastItem;
    $[25] = returnLegId;
    $[26] = tripId;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== canEditBoundaryStays || $[29] !== hasEndStay || $[30] !== isLastGroup) {
    t11 = canEditBoundaryStays && isLastGroup && !hasEndStay && <TripBoundaryStay position="end" />;
    $[28] = canEditBoundaryStays;
    $[29] = hasEndStay;
    $[30] = isLastGroup;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t9) {
    t12 = <div className={styles.timelineItems}>{t9}{t10}{t11}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12 || $[37] !== t8) {
    t13 = <div className={styles.timelineContent}>{t8}{t12}</div>;
    $[36] = t12;
    $[37] = t8;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t13 || $[40] !== t6 || $[41] !== t7) {
    t14 = <section className={styles.timelineGroup}>{t3}{t6}{t7}{t13}</section>;
    $[39] = t13;
    $[40] = t6;
    $[41] = t7;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
}